<template>
  <figure class="publication-image">
    <img
      class="publication-image__picture"
      :src="item.path"
      :alt="item.alt"
      loading="lazy"
      decoding="async"
    >

    <figcaption v-if="item.caption" class="publication-image__caption t2">
      {{ item.caption }}
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
  import type { PublicationImageProps } from './types';

  defineProps<PublicationImageProps>();
</script>

<style lang="scss">
  @use './style.scss';
</style>
